import { useCallback } from "react";
import { MAPSTYLES, MAPURL, STOREPROPTYPES } from "./lib/constants";
import Map from "../Map";
import styles from "./styles/card.module.css";

export function StoreCardMap({ store }) {
  if (!store) {
    return null;
  }
  const markersProps = [
    {
      coords: { lat: store.geopoint.lat, lng: store.geopoint.lng },
      title: `Kotn: ${store.city}`,
    },
  ];

  const mapLink = MAPURL + store.address;

  function addMarkers(map, markers) {
    markers.forEach((mark, index) => {
      const marker = new window.google.maps.Marker({
        map,
        position: mark.coords,
        label: `${index + 1}`,
        title: store.city,
        icon: {
          url: "https://kotn.com/favicon.svg",
          scaledSize: new google.maps.Size(40, 40),
        },
      });
      marker.addListener(`click`, () => {
        window.open(mapLink);
      });
    });
  }

  const mapProps = {
    options: {
      center: { lat: store.geopoint.lat, lng: store.geopoint.lng },
      zoom: 16,
      styles: MAPSTYLES,
      disableDefaultUI: true,
    },
    onMount: addMarkers,
    onMountProps: markersProps,
  };

  const MemoMap = useCallback(<Map {...mapProps} />, []);

  return <div className={styles.mapWrapper}>{MemoMap}</div>;
}

StoreCardMap.propTypes = {
  store: STOREPROPTYPES.isRequired,
};
